module.exports.GET_CLIENT = 'GET_CLIENT';
module.exports.ERROR_CLIENT = 'ERROR_CLIENT';
module.exports.INSTANCE_RUNNING_STATUS = 'INSTANCE_RUNNING_STATUS';
